/*
Ideally the Storyblok root would be set directly in the .env and accessible from frontend with the prefix 'NEXT_PUBLIC_'.
However, due to the "environment/storyblok" only accessible from the server side i have made this file.
*/
export const PROD_SPACE_ROOT = 'o2-co-uk';
export const INT_SPACE_ROOT = 'en/o2-content-pages';

export const replaceSbRoot = (path: string) => {
  if (path.startsWith(PROD_SPACE_ROOT)) {
    return path.replace(PROD_SPACE_ROOT, '');
  }
  if (path.startsWith(INT_SPACE_ROOT)) {
    return path.replace(INT_SPACE_ROOT, '');
  }
  return path;
};
